import React from "react";

const ErrorPage = () => {
  return (
    <div className="h-[60vh] flex justify-center items-center flex-col">
      <div className="text-9xl font-medium">404</div>
      <div className="text-lg text-center">Looks like this page does not exist</div>
    </div>
  );
};

export default ErrorPage;
